import { PrinterTwoTone, ZoomInOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  get_pdf_movimiento_traslado,
  movimientoSetActive,
  movimientosTrasladoStartLoading,
  showModalDetalle,
} from "../../../actions/inventario";
import { DocumentPrintModal, MoreOptionsColumn, TableUi } from "../../ui";
import { TypeSizeReportConstants } from "../../../types/typesConstants";
const key_opts = {
  print_modal: "print_modal",
};
const itemsMoreOptions = (data) => {
  let opts = [];
  opts = [
    ...opts,
    {
      label: "Imprimir",
      key: key_opts.print_modal,
      icon: <PrinterTwoTone twoToneColor="#eb2f96" />,
    },
  ];
  return opts;
};
const columns_table = (acciones) => {
  const { onHandleDetalleMovimiento, handleMenuItemClick } = acciones;
  return [
    {
      title: "#",
      dataIndex: "nro",
      key: "nro",
      align: "center",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Fecha emisión",
      dataIndex: "fechaemision",
      key: "fechaemision",
      align: "center",
    },
    {
      title: "Comprobante",
      dataIndex: "comprobante_movimiento",
      key: "comprobante_movimiento",
      align: "center",
    },
    {
      title: "Almacén Inicial",
      dataIndex: "almacenorigen_nombre",
      key: "almacenorigen_nombre",
    },
    {
      title: "Almacén Destino",
      dataIndex: "almacendestino_nombre",
      key: "almacendestino_nombre",
    },
    {
      title: "Detalle",
      dataIndex: "detalle",
      key: "detalle",
      align: "center",
      render: (text, record) => (
        <Button
          size="small"
          onClick={() => {
            onHandleDetalleMovimiento(record);
          }}
        >
          <ZoomInOutlined style={{ color: "#1890ff" }} />
        </Button>
      ),
    },
    {
      title: "Observación",
      dataIndex: "observacion",
      key: "observacion",
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      render: (text, record) => (
        <>
          <Space size="middle">
            <MoreOptionsColumn
              data={record}
              MenuItems={itemsMoreOptions}
              handleMenuItemClick={handleMenuItemClick}
            />
          </Space>
        </>
      ),
    },
  ];
};
export const MovimientoTrasladoTable = ({
  movimientos,
  loading,
  paginator,
}) => {
  const dispatch = useDispatch();
  const [comprobantemovimiento, setComprobanteMovimiento] = useState(null);
  const [openPrintModal, setOpenPrintModal] = useState(false);
  const handleOpenPrintModal = (row) => {
    setComprobanteMovimiento(row);
    setOpenPrintModal(true);
  };
  const handleHidePrintModal = () => setOpenPrintModal(false);
  const onHandleDetalleMovimiento = (data) => {
    dispatch(movimientoSetActive(data));
    dispatch(showModalDetalle(true));
  };
  const handlePrintDocument = async (
    document,
    size_report = TypeSizeReportConstants.R_80,
  ) => {
    const data = await get_pdf_movimiento_traslado(document?.id, size_report);
    return data;
  };
  const handleMenuItemClick = (e, field) => {
    switch (e.key) {
      case key_opts.print_modal:
        handleOpenPrintModal(field);
        break;
      default:
        break;
    }
  };
  const handleLoadData = (page = 1, page_size = 10) => {
    let searchFormData = JSON.parse(localStorage.getItem("SearhFormTable"));
    searchFormData = { ...searchFormData, page, page_size };
    dispatch(movimientosTrasladoStartLoading(searchFormData));
  };
  return (
    <>
      <TableUi
        columns={columns_table({
          onHandleDetalleMovimiento,
          handleMenuItemClick,
        })}
        rowKey="id"
        data={movimientos}
        loading={loading}
        size="small"
        pagination={{
          align: "start",
          showSizeChanger: true,
          total: paginator?.count,
          onChange: (page, page_size) => handleLoadData(page, page_size),
          showTotal: (total) => {
            const xTotal = movimientos?.length > 0 ? total : 0;
            return `Total ${xTotal} items`;
          },
        }}
      />
      <DocumentPrintModal
        open={openPrintModal}
        handleCancel={handleHidePrintModal}
        document={comprobantemovimiento}
        handlePrintDocument={(document, size_report) =>
          handlePrintDocument(document, size_report)
        }
        formats={[TypeSizeReportConstants.R_80, TypeSizeReportConstants.R_A4]}
      />
    </>
  );
};
